import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'src/reducers';
import { AppContext } from '@prisjakt/ui-app-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';
import RouteContext from 'src/routes/context';
import { IFilterState } from 'src/areas/product/types';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import { priceShippingDisplay } from 'src/areas/product/actions/product';
import { getAllFilters } from '../utils/filters-config';
import { getFiltersFromUserSettings, defaultHiddenListOptions } from '../utils';
import { FilterEnum } from '../types';
import FilterOption from './filter-option';

export const IncludeShippingFilter = () => {
  const { t, market } = useContext(AppContext);
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const dispatch = useDispatch();
  const { selectedFilters, changeSingleFilterSelection } = useContext(
    PriceListFilterContext
  );
  const [hiddenListOptions] = useState<string[]>(
    defaultHiddenListOptions(market)
  );
  const priceDisplay = useSelector(
    (state: AppState) => state.areas.product.priceDisplay
  );
  const filtersConfig = getAllFilters(t, selectedFilters, hiddenListOptions);
  const incShippingFilter = filtersConfig.find(
    f => f.name === FilterEnum.PRICES_INC_SHIPPING
  );

  const onPricesIncShippingOptionChanged = (name: string, val: boolean) => {
    const selectedPriceDisplay =
      priceDisplay === PriceDisplayEnum.PRICE
        ? PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
        : PriceDisplayEnum.PRICE;
    dispatch(priceShippingDisplay(selectedPriceDisplay));
    changeSingleFilterSelection(name, val, routeDispatch);
  };

  const setPricesIncShippingOptionFromUserSettings = (
    storedFilters: IFilterState
  ) => {
    const isPricesIncShipping = storedFilters[FilterEnum.PRICES_INC_SHIPPING];
    if (isPricesIncShipping !== null) {
      const selectedPriceDisplay = isPricesIncShipping
        ? PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
        : PriceDisplayEnum.PRICE;
      if (selectedPriceDisplay !== priceDisplay) {
        dispatch(priceShippingDisplay(selectedPriceDisplay));
      }
    }
  };

  useEffectOnMount(() => {
    const storedFilters = getFiltersFromUserSettings(selectedFilters);
    setPricesIncShippingOptionFromUserSettings(storedFilters);
  });

  if (!incShippingFilter) {
    return null;
  }

  return (
    <FilterOption
      key={incShippingFilter.name}
      name={incShippingFilter.name}
      defaultValue={incShippingFilter.checked}
      onFilterChangedHandler={onPricesIncShippingOptionChanged}
      label={incShippingFilter.label}
    />
  );
};
